import React from "react";
import { connect } from 'redux-bundler-react';

class ThemeListItem extends React.Component {
  handleClick = () => {
    const { doSetTheme, theme } = this.props;
    doSetTheme(theme);
  };
  render() {
    const { theme } = this.props;
    return (
      <li
        onClick={this.handleClick}
        title={theme}
        className={"list-group-item pointer overflow-ellipsis " + theme}
        style={{ margin: "3px", padding: "2px", minHeight:"28px" }}
      >
        {theme}
      </li>
    );
  }
}

export default connect('doSetTheme', ThemeListItem);
